import React, { useContext, useEffect } from 'react'
import clsx from 'clsx'

import { ProgressIndicator } from '@jarvis/react-setup-and-onboarding-addons'
import { ConfigContext } from '@/store'

import classes from './LoadingBackdrop.module.scss'

export default function LoadingBackdrop() {
  const { setBackgroundClassName, isHpx } = useContext(ConfigContext)

  useEffect(() => {
    setBackgroundClassName(classes.backgroundContainer)
    return () => {
      setBackgroundClassName(null)
    }
  }, [])

  return (
    <div
      data-testid="container-loading"
      className={clsx(classes.loadingContainer, {
        [classes.hpx]: isHpx
      })}
      hidden
    >
      <ProgressIndicator
        data-testid="spinner"
        size="large"
        appearance="circular"
        behavior="indeterminate"
      />
    </div>
  )
}
